import WorkbenchLink from '@zeus/core/WorkbenchLink';
import { useOrganization } from '_/contexts/OrganizationContext';
import { ISource } from '_/types/sources/source.types';
import React, { ReactElement } from 'react';

interface ExtractorSourceLinkProps {
  source: ISource;
}

function ExtractorSourceLink({ source }: ExtractorSourceLinkProps): ReactElement | string {
  const { selectedOrgSlug: orgSlug } = useOrganization();
  const projectSlug = source?.collection?.project?.slug;
  const collectionSlug = source?.collection?.slug;
  const sourceSlug = source?.slug;

  if (!projectSlug || !collectionSlug || !sourceSlug) {
    return source.name;
  } else {
    return (
      <WorkbenchLink href={`/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/sources/${sourceSlug}/home`}>
        {source.name}
      </WorkbenchLink>
    );
  }
}

export default ExtractorSourceLink;
